import {useState, useEffect, useRef, useCallback} from "react";
import {inject, observer} from "mobx-react";
import {db} from "../../../../firebase/Firebase";
import {LayoutChild} from "../../../../palette/Palette";
import Alerts from "../../../../palette/Alerts";
import UsersGrid from "./UsersGrid";
import {Animated} from "react-animated-css";
import UserForm from "./UserForm";
import UsersEditForm from "./UsersEditForm";

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function Users(props) {

    const {DataStore} = props

    const {companyName, finished, idCompany} = DataStore

    const [load, setLoad] = useState(false)
    const [visibleGrid, setVisibleGrid] = useState(true)
    const [visibleForm, setVisibleForm] = useState(false)
    const [edit, setEdit] = useState(false)
    const [trigger, setTrigger] = useState(false)
    const [dataEdit, setDataEdit] = useState({})
    const [dataUsers, setDataUsers] = useState([])

    const isMounted = useMountedState()

    useEffect(() => {

        const usersRef = db.collection('Users')
        const GetUsers = async () => {
            let ID = 0
            await usersRef.where('companyName', '==', companyName).get()
                .then(snapshot => {
                    const dataArray = []
                    snapshot.forEach(doc => {
                        ID = ID + 1
                        const status = doc.data().status ? 'Cuenta activa' : 'Cuenta eliminada'
                        const obj = {...doc.data(), id: doc.id, status: status, ID: ID}
                        dataArray.push(obj)
                    });
                    setDataUsers(dataArray)
                    setLoad(true)
                })
        }

        if (isMounted()) {
            GetUsers().catch(() => {
            })
        }

    }, [companyName, isMounted, trigger])

    return (
        <>
            {!finished &&
            <LayoutChild percent={95} margin="auto" top={25}>
                <Alerts severity={'error'}
                        body={'¡No se han terminado de configurar los datos de la empresa!'}/>
            </LayoutChild>}

            {(finished && visibleGrid) &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleGrid}>
                <UsersGrid dataSource={dataUsers} DataStore={DataStore} setVisibleGrid={setVisibleGrid}
                           setEdit={setEdit} setVisibleForm={setVisibleForm} setTrigger={setTrigger} trigger={trigger}
                           loading={load} setDataEdit={setDataEdit}/>
            </Animated>
            }

            {visibleForm &&
            <UserForm setVisibleForm={setVisibleForm} setTrigger={setTrigger} trigger={trigger} DataStore={DataStore}
                      setVisibleGrid={setVisibleGrid}/>
            }

            {edit &&
            <UsersEditForm setTrigger={setTrigger} trigger={trigger} companyName={companyName}
                           setVisibleGrid={setVisibleGrid}
                           idCompany={idCompany} setEdit={setEdit} dataSource={dataEdit}/>}

        </>
    )
}

export default inject('DataStore')(observer(Users));